export default __webpack_public_path__ + "static/4-45502e3e1d9ae0a2602f56a58f7e7e0e.jpg";